var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('b-container',[_c('h3',[_vm._v(" Site name: "),_c('span',{staticClass:"sitename"},[_vm._v(_vm._s(_vm.feature.properties.name))]),_vm._v(" ; Site ID: "+_vm._s(_vm.feature.id)+" ")]),_c('p',[_vm._v(_vm._s(_vm.feature.geometry))]),_c('hr'),_c('FeatureMap',{attrs:{"feature":_vm.feature}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }